import request from '../../../core/wrappers/axios-wrapper';
import { AIPromptCommandUrl } from '../../../types/constants/apiUrls/AIPrompt/AIPromptCommand';
import { RequestType } from '../../../types/enums/request-enums';
import { AIPromptCategory, AIModelType } from '../../../types/enums/ai-prompt-enums';

/**
 * AI Prompt oluşturma request interface
 */
export interface CreateAIPromptRequest {
    name: string;
    code: string;
    category: AIPromptCategory;
    modelType: AIModelType;
    promptText: string;
    isSystemPrompt: boolean;
    isActive: boolean;
}

/**
 * AI Prompt güncelleme request interface
 */
export interface UpdateAIPromptRequest {
    name: string;
    code: string;
    category: AIPromptCategory;
    modelType: AIModelType;
    promptText: string;
    isSystemPrompt: boolean;
    isActive: boolean;
}

/**
 * Yeni AI Prompt oluşturur
 * @param data Oluşturulacak prompt bilgileri
 * @returns Promise
 */
export const CreateAIPrompt = (data: CreateAIPromptRequest) =>
    request({
        url: AIPromptCommandUrl.CreateAIPrompt,
        method: RequestType.POST,
        data: data,
    });

/**
 * Mevcut AI Prompt'u günceller
 * @param id Prompt ID
 * @param data Güncellenecek bilgiler
 * @returns Promise
 */
export const UpdateAIPrompt = (id: number, data: UpdateAIPromptRequest) =>
    request({
        url: `${AIPromptCommandUrl.UpdateAIPrompt}/${id}`,
        method: RequestType.PUT,
        data: data,
    });

/**
 * AI Prompt'u siler (Soft delete)
 * @param id Silinecek prompt ID
 * @returns Promise
 */
export const DeleteAIPrompt = (id: number) =>
    request({
        url: `${AIPromptCommandUrl.DeleteAIPrompt}/${id}`,
        method: RequestType.DELETE,
    });

